var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartPie({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chart-pie"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2895 12.5263H11.9737V6.21053C11.9737 5.93135 11.8628 5.66361 11.6654 5.4662C11.468 5.2688 11.2002 5.15789 10.9211 5.15789C9.25553 5.15789 7.6274 5.65178 6.24257 6.5771C4.85773 7.50241 3.77839 8.8176 3.14102 10.3563C2.50365 11.8951 2.33688 13.5883 2.66181 15.2218C2.98674 16.8553 3.78877 18.3558 4.96647 19.5335C6.14418 20.7112 7.64467 21.5133 9.27819 21.8382C10.9117 22.1631 12.6049 21.9964 14.1437 21.359C15.6824 20.7216 16.9976 19.6423 17.9229 18.2574C18.8482 16.8726 19.3421 15.2445 19.3421 13.5789C19.3421 13.2998 19.2312 13.032 19.0338 12.8346C18.8364 12.6372 18.5686 12.5263 18.2895 12.5263Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0789 2C13.7998 2 13.532 2.1109 13.3346 2.30831C13.1372 2.50572 13.0263 2.77346 13.0263 3.05263V10.4211C13.0263 10.7002 13.1372 10.968 13.3346 11.1654C13.532 11.3628 13.7998 11.4737 14.0789 11.4737H21.4474C21.7265 11.4737 21.9943 11.3628 22.1917 11.1654C22.3891 10.968 22.5 10.7002 22.5 10.4211C22.4975 8.18842 21.6095 6.04795 20.0308 4.46924C18.4521 2.89053 16.3116 2.00251 14.0789 2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPie);
export default __webpack_public_path__ + "static/media/chart-pie.40da674723f6317f9e7943b1d69ae30e.svg";
export { ForwardRef as ReactComponent };